module.exports = __webpack_public_path__ + "img/office.3374e350.png";